var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bascinfo"},[_vm._v(" 订单号："+_vm._s(_vm.stldata.orderno)+" "),_c('span',{staticClass:"ml20"},[_vm._v("患者姓名："+_vm._s(_vm.stldata.name))])]),_c('div',{ref:"canavs"},[(_vm.loading)?_c('div',{staticClass:"_load"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v("渲染中.. ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }